import { useContext } from 'react'
import { useQuery } from 'react-query'
import axiosInstance from 'services/axiosInstance'
import { SnackBarContext } from 'context/SnackBarContext'

const useGet = (key: string, url: string, configs?: any) => {
  const { setShowSnackBar } = useContext(SnackBarContext)
  const get = async () => {
    try {
      const { data } = await axiosInstance.get(url)
      return data
    } catch (error: any) {
      if (error?.response) {
        const apiError = error.response.data
        if (apiError.s === 0) {
          setShowSnackBar({ open: true, message: `${apiError?.m}`, severity: '' })
        }
      }
    }
  }
  const defaultConfig = {
    enabled: false,
    refetchOnWindowFocus: false,
    retry: false,
    ...configs,
  }
  return useQuery(key, get, defaultConfig)
}

export default useGet
